import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "./firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Navbar from "./Navbar";
import "./Edit.css";

const EditQuiz = () => {
    const { quizId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [quizData, setQuizData] = useState(null);

    useEffect(() => {
        const fetchQuiz = async () => {
            const quizRef = doc(db, "quizzes", quizId);
            const quizSnap = await getDoc(quizRef);
            if (quizSnap.exists()) {
                setQuizData(quizSnap.data());
            }
            setLoading(false);
        };
        fetchQuiz();
    }, [quizId]);

    const handleInputChange = (field, value) => {
        setQuizData(prev => ({ ...prev, [field]: value }));
    };

    const handleQuestionChange = (index, field, value) => {
        const updatedQuestions = [...quizData.questions];
        updatedQuestions[index][field] = value;
        setQuizData(prev => ({ ...prev, questions: updatedQuestions }));
    };

    const handleOptionChange = (qIdx, optIdx, value) => {
        const updatedQuestions = [...quizData.questions];
        updatedQuestions[qIdx].options[optIdx] = value;
        setQuizData(prev => ({ ...prev, questions: updatedQuestions }));
    };

    const removeQuestion = (idx) => {
        const updatedQuestions = quizData.questions.filter((_, i) => i !== idx);
        setQuizData(prev => ({ ...prev, questions: updatedQuestions }));
    };

    const addQuestion = () => {
        setQuizData(prev => ({
            ...prev,
            questions: [...prev.questions, { type: "multiple-choice", question: "", options: ["", ""], answer: "" }]
        }));
    };

    const handleSave = async () => {
        const quizRef = doc(db, "quizzes", quizId);
        await updateDoc(quizRef, quizData);
        alert("Quiz updated successfully!");
        navigate("/dashboard");
    };

    if (loading) return <p>Loading...</p>;

    return (
        <>
            <Navbar />
            <div className="container">
                <h2 className="title">Edit Quiz</h2>

                <div className="form-group">
                    <label>Title:</label>
                    <input
                        type="text"
                        value={quizData.title}
                        onChange={e => handleInputChange("title", e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Description:</label>
                    <textarea
                        value={quizData.description}
                        onChange={e => handleInputChange("description", e.target.value)}
                    />
                </div>

                <div className="form-group checkbox-group">
                    <label>Public:</label>
                    <input
                        type="checkbox"
                        checked={quizData.public}
                        onChange={e => handleInputChange("public", e.target.checked)}
                    />
                </div>

                <div className="question-section">
                    <h3 className="section-title">Questions:</h3>
                    {quizData.questions.map((q, idx) => (
                        <div key={idx} className="question-card">

                            <div className="row-group">
                                <div className="form-group">
                                    <label>Type:</label>
                                    <select value={q.type} onChange={(e) => handleQuestionChange(idx, "type", e.target.value)}>
                                        <option value="multiple-choice">Multiple Choice</option>
                                        <option value="true-false">True/False</option>
                                        <option value="open-ended">Open-Ended</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Question:</label>
                                    <input type="text" value={q.question} onChange={(e) => handleQuestionChange(idx, "question", e.target.value)} />
                                </div>
                            </div>


                            {q.type === "multiple-choice" && (
                                <div className="form-group">
                                    <label>Options:</label>
                                    <div className="option-grid">
                                        {q.options.map((opt, i) => (
                                            <input
                                                key={i}
                                                type="text"
                                                value={opt}
                                                placeholder={`Option ${i + 1}`}
                                                onChange={(e) => handleOptionChange(idx, i, e.target.value)}
                                            />
                                        ))}
                                    </div>

                                    <div className="form-group">
                                        <label>Answer:</label>
                                        <input
                                            type="text"
                                            value={q.answer}
                                            onChange={(e) => handleQuestionChange(idx, "answer", e.target.value)}
                                            placeholder="Correct answer text"
                                            required
                                        />
                                    </div>
                                </div>
                            )}



                            {q.type === "true-false" && (
                                <div className="form-group">
                                    <label>Answer:</label>
                                    <select value={q.answer} onChange={(e) => handleQuestionChange(idx, "answer", e.target.value)}>
                                        <option value="True">True</option>
                                        <option value="False">False</option>
                                    </select>
                                </div>
                            )}

                            {q.type === "open-ended" && (
                                <div className="form-group">
                                    <label>Answer:</label>
                                    <input
                                        type="text"
                                        value={q.answer}
                                        onChange={(e) => handleQuestionChange(idx, "answer", e.target.value)}
                                        placeholder="Correct answer text"
                                        required
                                    />
                                </div>

                            )}

                            <br />
                            <button className="remove-btn" onClick={() => removeQuestion(idx)} >Remove Question</button>
                        </div>
                    ))}

                    <button className="add-btn" onClick={addQuestion}>Add Question</button>
                </div>
                <button className="submit-btn" onClick={handleSave} style={{ marginLeft: "50px", marginTop: "20px" }}>Save Changes</button>
                <button className="cancel-btn" onClick={() => navigate("/dashboard")}>Cancel</button>
            </div>
        </>
    );
};

export default EditQuiz;
